import * as types from '../constants/ActionTypes';

export const startRecording = () => ({ type: types.SPEECH_START_RECORDING });

export const endRecording = () => ({ type: types.SPEECH_END_RECORDING });

export const soundEndRecording = () => ({ type: types.SOUND_END_RECORDING });

export const soundStartRecording = () => ({ type: types.SOUND_START_RECORDING });

export const speechRecognitionRequest = (query) => ({
  type: types.SPEECH_RECOGNITION_REQUEST,
  payload: query,
});

export const resetSpeechQuery = () => ({ type: types.RESET_SPEECH_QUERY });
